export const FLAG_GETTING_USER_SECURITY_PROFILES =
  'FLAG_GETTING_USER_SECURITY_PROFILES';
export const GET_USER_SECURITY_PROFILES = 'GET_USER_SECURITY_PROFILES';
export const CLEAR_USER_SECURITY_PROFILES = 'CLEAR_USER_SECURITY_PROFILES';
